import { MicroviewCommunicationChannel } from '@tableau/microview-communication-service';

export class HelpServiceChannel extends MicroviewCommunicationChannel<{ category: string }, Promise<string>> {
  public name: string = 'HelpServiceChannel';
  public namespace: string = 'SearchMicroview.HelpService';
}
